import React, { useEffect } from 'react';
import { AlertTriangle, ArrowRight, EyeOff } from 'lucide-react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Footer } from '../../components/layout/Footer';
import { UNASSIGNED_PRODUCTS } from '../../data/unassignedProducts';
export function CategoryCleanupReview() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Review / Unassigned — Internal Category Cleanup';
    return () => {
      document.title = previousTitle;
    };
  }, []);
  const clientReview = UNASSIGNED_PRODUCTS.filter(p => p.action === 'Client review');
  const recommended = UNASSIGNED_PRODUCTS.filter(p => p.action === 'Recommended move');
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-2001" data-mp="3ke13vc2clu8z">
      <TopBar data-id="element-2002" data-mp="2czoat2f042m6" />
      <Header data-id="element-2003" data-mp="2cw0ig6lalm91" />

      <main className="flex-grow py-10 lg:py-14" data-id="element-2004" data-mp="28wj9h36nq6z4">
        <div className="max-w-5xl mx-auto px-4" data-id="element-2005" data-mp="28vqdmx98l1vr">
          <div className="inline-flex items-center gap-2 bg-brand-charcoal text-white text-xs font-bold uppercase tracking-[0.12em] px-3 py-1.5 rounded-sm mb-5" data-id="element-2006" data-mp="3t7kdemwpifkx">
            <EyeOff size={14} aria-hidden="true" data-id="element-2007" data-mp="20r56z3hxg6w" />
            Internal report — not linked in site navigation
          </div>

          <h1 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-2008" data-mp="3k98c9qy7rze8">
            Review / Unassigned products
          </h1>
          <p className="text-lg text-brand-muted leading-relaxed max-w-3xl" data-id="element-2009" data-mp="3ag19mduuyxhu">
            These are products currently assigned only to root / All Categories,
            or with no meaningful category assignment. Review / Unassigned is an
            internal, report-only bucket: it is not a customer-facing category
            and does not appear in the main navigation or the Shop by Need
            cards.
          </p>

          <div className="mt-6 bg-brand-goldSoft border border-brand-gold/40 rounded-xl p-5 flex items-start gap-3 max-w-3xl" data-id="element-2010" data-mp="2rj03gppkircb">
            <AlertTriangle size={20} className="text-brand-maroon shrink-0 mt-0.5" aria-hidden="true" data-id="element-2011" data-mp="1212yw0e3ceqq" />
            <p className="text-sm text-brand-charcoal leading-relaxed" data-id="element-2012" data-mp="x8tdmxnx82us">
              Door Mats &amp; Welcome Mats is being removed from the
              customer-facing structure, so the mat products below need an
              explicit keep, move, or discontinue decision before cleanup is
              applied.
            </p>
          </div>

          <section className="mt-10" aria-labelledby="audit-heading" data-id="element-2013" data-mp="1g13ylcimdg4m">
            <div className="flex flex-wrap items-baseline justify-between gap-3 mb-4" data-id="element-2014" data-mp="1fyrht2ollbt5">
              <h2 id="audit-heading" className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-2015" data-mp="1bxfreuxwgmjw">
                15-product audit
              </h2>
              <p className="text-sm text-brand-muted" data-id="element-2016" data-mp="lez561tufze">
                {clientReview.length} need client decisions ·{' '}
                {recommended.length} have recommended destinations
              </p>
            </div>

            <div className="bg-white border border-brand-border rounded-xl overflow-hidden" data-id="element-2017" data-mp="2c7grx78m6jpf">
              <div className="overflow-x-auto" data-id="element-2018" data-mp="2c52xn0lrdbix">
                <table className="w-full min-w-[720px] text-left text-sm" data-id="element-2019" data-mp="2g7zlp6u2hzu9">
                  <thead className="bg-brand-background text-brand-charcoal" data-id="element-2020" data-mp="2l0an6e4ghtox">
                    <tr data-id="element-2021" data-mp="2pyuaoiyp7dje">
                      <th scope="col" className="px-5 py-3 font-bold" data-id="element-2022" data-mp="2pzdk1baa8tlt">
                        SKU
                      </th>
                      <th scope="col" className="px-5 py-3 font-bold" data-id="element-2023" data-mp="2uwnc6yp23jdc">
                        Product
                      </th>
                      <th scope="col" className="px-5 py-3 font-bold" data-id="element-2024" data-mp="2zux8jcmioq0j">
                        Suggested action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-brand-border/70" data-id="element-2025" data-mp="15ktm6uj1hwbd">
                    {UNASSIGNED_PRODUCTS.map(product => <tr key={product.sku} className="align-top" data-id="element-2026" data-mp="ea5mnelo5z8m">
                        <td className="px-5 py-4 font-mono text-xs text-brand-charcoal whitespace-nowrap" data-id="element-2027" data-mp="e8m93vree2aj">
                          {product.sku}
                        </td>
                        <td className="px-5 py-4 text-brand-charcoal font-medium" data-id="element-2028" data-mp="o7advsudgkwa">
                          {product.title}
                        </td>
                        <td className="px-5 py-4" data-id="element-2029" data-mp="3rp2ajkjgdt0t">
                          <span className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide px-2 py-1 rounded-sm mb-2 ${product.action === 'Client review' ? 'bg-brand-goldWash text-brand-charcoal border border-brand-gold/40' : 'bg-brand-maroon/10 text-brand-maroon border border-brand-maroon/25'}`} data-id="element-2030" data-mp="3rpv6rrksd04p">
                            {product.action === 'Recommended move' && <ArrowRight size={12} aria-hidden="true" data-id="element-2031" data-mp="1jgnm7g54fv60" />}
                            {product.action}
                          </span>
                          <div className="text-brand-charcoal font-medium" data-id="element-2032" data-mp="1ahk2c9y4rbqg">
                            {product.suggestion}
                          </div>
                          <p className="text-brand-muted mt-1 leading-relaxed" data-id="element-2033" data-mp="1egj7nvnrxaif">
                            {product.note}
                          </p>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-2034" data-mp="1y5ju9d76h86m" />
    </div>;
}